import { render, staticRenderFns } from "./refundsForSiyu.vue?vue&type=template&id=7671c949&scoped=true"
import script from "./refundsForSiyu.vue?vue&type=script&lang=js"
export * from "./refundsForSiyu.vue?vue&type=script&lang=js"
import style0 from "./refundsForSiyu.vue?vue&type=style&index=0&id=7671c949&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7671c949",
  null
  
)

export default component.exports